module.exports = __webpack_public_path__ + "img/bobupe_bobocoin.gm.b07bd5e.png";